








import { Component, Prop, Vue } from 'vue-property-decorator'
import AppFormTable from '@core/components/AppFormTable.vue'
import { TableFormStructure } from '@master/model/structure/FormStructure'
import { options } from '@master/model/options/Options'
import { ScheduleTimeResponseDto } from './api'
import { ScheduleTimeRequestDto } from './model/ScheduleTimeRequestDto'

@Component({
  components: {
    AppFormTable
  }
})
export default class ScheduleListSection extends Vue {
  @Prop({ default: () => [] }) private schedules: ScheduleTimeResponseDto[]
  @Prop({ default: () => [] }) frequencyOptions: options[]
  @Prop({ default: {} }) private tasksNiceName: {}

  get tableStructure (): TableFormStructure<ScheduleTimeRequestDto> {
    return [
      {
        label: 'Task Name',
        model: {
          get: (index) => this.tasksNiceName[this.schedules[index].name],
          set: (index, val) => {
            // Do not need to add any values
          }
        },
        type: 'text',
        disabled: true
      },
      {
        label: 'Select Time',
        key: 'time',
        type: 'time',
        disabled: true
      },
      {
        label: 'Frequency',
        key: 'frequency',
        type: 'dropdown',
        options: this.frequencyOptions,
        disabled: true
      },
      {
        label: 'Status',
        model: {
          get: (index) => this.schedules[index].enable ? 'Scheduled' : 'Not Scheduled',
          set: (index, val) => {
            // Do not need to add any values
          }
        },
        type: 'text',
        disabled: true
      }
    ]
  }

  scheduleClicked (index: number) {
    this.$emit('schedule-clicked', this.schedules[index])
  }
}
